module.exports = fox => ({
	delay(delay = 100) {
		return new fox.Promise(resolve => {
			setTimeout(resolve, delay);
		});
	}
});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/common-stuffs/utils.es.js